export default {
  install(Vue, options) {
    //显示身份证号码
    Vue.prototype.showUser = function (idCard) {
      if (idCard) {
        var first = idCard.substr(0, 4);
        var last = idCard.substr(-4, 4);
        var full = first + " **** " + last;
        return full;
      }
    };
    Vue.prototype.coursetitle = function (title) {
      if (title.length > 36) {
        title = title.slice(0, 36);
        title = title + "...";
      }
      return title;
    };
    //导航栏切换
    Vue.prototype.tabClick = function (router) {
      // this.$store.state.tab = +id;
      this.$router.push(router);
    };
    /**
     * 根据路由meta中tab值，设置导航栏tab
     */
    Vue.prototype.setTab = function () {
      this.$store.state.tab = this.$route.meta.tab;
    };
    Vue.prototype.webhost = 'https://www.xjxtjcpx.com:8443/security-training/app/' // 正式
    // Vue.prototype.webhost = " http://test.xjxtjcpx.com:8443/security-training/app/";  // 测试
    // Vue.prototype.webhost = 'https://www.xjafpx.com:8443/security-training/app/'
    // Vue.prototype.webhost = "https://test.xjxtjcpx.com:8443/security-training/app/";
    // Vue.prototype.webhost = 'http://localhost:8089/security-training/app/'
    // Vue.prototype.webhost = "https://192.168.0.133:8443/security-training/app/";
  
  }
};



// WEBPACK FOOTER //
// ./src/lib/config.js